import React, { useState } from 'react';
import Modal from '@/components/common/Modal/Modal';
import { Footer } from '@/components/common/Modal';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import I18n from '@/modules/i18n';
import { TCI_AI_APPROACH_URL } from './aiFeatures.constants';

const CHECKBOX_ID = 'ai-features-authorization';

interface TurnOnAiFeaturesModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

// AIDEV-NOTE: Mounted only while open, so the authorization checkbox resets on every dismiss without
// the parent having to clear it. Do not lift `isAuthorized` back up.
const TurnOnAiFeaturesModal = ({ onCancel, onConfirm }: TurnOnAiFeaturesModalProps) => {
  const [isAuthorized, setIsAuthorized] = useState(false);

  return (
    <Modal
      isOpen
      closeModal={onCancel}
      footer={(
        <Footer
          primaryButtonCallback={onConfirm}
          primaryButtonClassName="btn btn--purple"
          primaryButtonDisabled={!isAuthorized}
          primaryButtonSubmit={false}
          primaryButtonText={I18n.t('turn_on')}
          secondaryButtonCallback={onCancel}
          wrapperClassName="tw-pr-4 tw-pb-4"
        />
      )}
      headerText={I18n.t('turn_on_ai_features')}
    >
      <div className="tw-p-4 tw-space-y-4">
        <Text size="sm">{I18n.t('turn_on_ai_features_body')}</Text>
        <Text size="sm">
          {I18n.t('turn_on_ai_features_blurb')}
          &nbsp;
          <a href={TCI_AI_APPROACH_URL} rel="noopener noreferrer" target="_blank">
            {I18n.t('beta_features_ai_approach_link')}
            <Icon className="tw-relative tw--top-px tw-ml-1 tw-align-middle" icon="ExternalLink" size={14} />
          </a>
        </Text>
        <label
          className="tw-flex tw-items-start tw-gap-2 tw-cursor-pointer tw-font-normal tw-mb-0"
          htmlFor={CHECKBOX_ID}
        >
          <input
            checked={isAuthorized}
            className="tw-cursor-pointer tw-mt-1"
            id={CHECKBOX_ID}
            type="checkbox"
            onChange={e => setIsAuthorized(e.target.checked)}
          />
          <Text size="sm" tag="span">{I18n.t('ai_features_authorization')}</Text>
        </label>
      </div>
    </Modal>
  );
};

export default TurnOnAiFeaturesModal;
